<template>
  <div class="home-container">
    <div class="c_header">
      <div class="c_switch"
      @click="handleSwitchLang"
      :class="[getLanguage() === 'cn' ? 'en' : 'cn']"></div>
      <div class="c_logo"></div>
      <div class="c_menu"></div>
    </div>
    <div class="c_banner">
      <div class="c_main_title"></div>
    </div>
    <div class="c_seperate">{{ $t('178ba26728') }}</div>
    <div class="bg_wrap">
      <atom-tabs v-model="currentTab" @change="handleTabChange" :swipeThreshold="3" >
        <atom-tab :title="item.title"
        v-for="item in tabData" :key="item.title"
        titleClass="c_tab_style"> </atom-tab>
      </atom-tabs>
      <atom-swipe :loop="false" :show-indicators="false" ref="mySwiper" :stop-propagation="false" @change="handleSwipeChange">
        <atom-swipe-item v-for="item in tabData" :key="item.title">
          <HomeCard :titleStr="item.title" :desc="item.desc" :imgUrl="item.imgUrl" />
        </atom-swipe-item>
      </atom-swipe>
      <div class="c_title">{{ $t('43bd0cb57c') }}</div>
      <div v-show="backup" class="c_beian">{{ backup }}</div>
      <ul class="c_func">
        <li v-for="item in funcList" :key="item.title">
          <div class="c_left">
            <div class="func_title">{{ item.title }}</div>
            <div class="func_desc">{{ item.desc }}</div>
          </div>
          <div class="c_right"></div>
        </li>
      </ul>
    </div>
    <div class="c_solution_block">
      <div class="c_title">{{ $t('015d1bcd47') }}</div>
      <div class="c_content">
        <div class="c_solute_item" v-for="item in solutionList" :key="item.title">
          <div class="c_solute_item_title">
            <span>{{ item.title }}</span>
            <span class="c_icon"></span>
          </div>
          <div class="c_solute_item_desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="c_title" style="margin-top: 0">{{ $t('d00426bc48') }}</div>
    <div class="c_instru"></div>
    <div class="c_footer">
      <div class="small_text">
        <div>{{ $t('9ff28b81c4') }}</div>
        <div>{{ companyConfig.companyEnName }}</div>
        <div>All rights reserved.</div>
        <div>{{ companyConfig.companyName }}</div>
        <div @click="handleJump">{{ companyConfig.icp }}</div>
      </div>
    </div>
    <div class="c_fixed_bottom">
      <div class="btn download" @click="handleDownload">{{ $t('4a7ee8f5ee') }}</div>
      <div class="btn trial" @click="handleTrial">{{ $t('601efab6ed') }}</div>
    </div>
  </div>
</template>
<script>
import HomeCard from '../components/HomeCard.vue';
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      backup: '网信算备330110245100501240021号',
      companyConfig: {
        companyName: '杭州同花顺数据开发有限公司版权所有',
        companyEnName: 'Copyright©HangZhou TongHuaShun Data Processing Co.,Ltd.',
        icp: '浙ICP备15046002号 浙金信备〔2021〕1号',
      },
      currentTab: 0,
      tabData: [
        {
          title: $t('e4cc999756'),
          desc: $t('49c8953b28'),
          imgUrl: require('../assets/imgs/terminal_bg.png'),
          jumpUrl: ''
        },
        {
          title: $t('68051bf4aa'),
          desc: $t('e5febe530a'),
          imgUrl: require('../assets/imgs/database_bg.png'),
          jumpUrl: ''
        },
        // {
        //   title: $t('31f8a7a967'),
        //   desc: $t('8f4105595a'),
        //   imgUrl: require('../assets/imgs/interface_bg.png'),
        //   jumpUrl: ''
        // },
        {
          title: $t('1c13a2694a'),
          desc: $t('aa9b49f713'),
          imgUrl: require('../assets/imgs/phone_bg.png'),
          jumpUrl: ''
        }
      ],
      funcList: [
        {
          title: $t('74bb5fe5c1'),
          desc: $t('fb92103b7c')
        },
        {
          title: $t('a56b94485d'),
          desc: $t('5c7fe7de83')
        },
        // {
        //   title: 'ChatFinD',
        //   desc: $t('fae7335381')
        // },
        // {
        //   title: $t('c1dbcf0924'),
        //   desc: $t('e4cdee6595')
        // }
      ],
      solutionList: [
        {
          title: $t('a13f0cfec8'),
          desc: $t('e31ff0f841')
        },
        {
          title: $t('f14b4f28c4'),
          desc: $t('fb771c3a67')
        },
        {
          title: $t('bf8214c421'),
          desc: $t('e0212b388a')
        },
        {
          title: $t('04c9e3ab21'),
          desc: $t('21c42cd822')
        },
        {
          title: $t('c7814cb2c3'),
          desc: $t('ece231a465')
        },
        {
          title: $t('0d98c74797'),
          desc: $t('ec0572e733')
        }
      ]
    };
  },
  created() {
    let host = window.location.host;
      if (host.indexOf('.cn')>-1) {
        this.companyConfig = {
          companyName: '浙江同花顺网络科技有限公司版权所有',
          companyEnName: 'Copyright Zhejiang RoyalFlush Network Technology Co.,Ltd.',
          icp: '浙ICP备10056399号-27 浙金信备〔2021〕1号'
        }
        this.backup = '网信算备330110807790401230013号'
      }
      if (host.indexOf('51ifind.com.cn') > -1) {
        this.companyConfig = {
          companyName: '杭州同花顺数据开发有限公司版权所有',
          companyEnName: 'Copyright©HangZhou TongHuaShun Data Processing Co.,Ltd.',
          icp: '浙ICP备15046002号 浙金信备〔2021〕1号'
        }
        this.backup = '网信算备330110245100501240021号'
      }
      if(host.indexOf('5ifind.com.cn')>-1) {
        this.companyConfig = {
          companyName: '杭州同顺传媒科技有限公司版权所有',
          companyEnName: 'Copyright©HangZhou TongShun Media Technology Co.,Ltd.',
          icp: '浙ICP备16031093号-5 浙金信备〔2021〕1号'
        }
        this.backup = '';
      }else if(host.indexOf('5ifind.cn')>-1) {
        this.companyConfig = {
          companyName: '浙江同花顺网络科技有限公司版权所有',
          companyEnName: 'Copyright Zhejiang RoyalFlush Network Technology Co.,Ltd.',
          icp: '浙ICP备10056399号-28 浙金信备〔2021〕1号'
        }
        this.backup = '网信算备330110807790401230013号'
      }
  },
  components: {
    HomeCard
  },
  methods: {
    handleJump() {
      window.open('https://beian.miit.gov.cn/home', '_blank');
    }, 
    // tab底部宽度自适应
    changeBarWidth() {
      this.$nextTick(() => {
        const dom = this.$el.querySelector('.atom-tab--active');
        setTimeout(() => {
          const dom1 = this.$el.querySelector('.atom-tabs__line');
          if (dom && dom1) {
            dom1.style.width = `${dom.offsetWidth - 28}px`;
          }
        }, 200);
      });
    },
    handleDownload() {
      this.$Talog({
        id: 'iFinD_sjgw_sy_download'
      });
      window.open(`${location.origin}/thsft/iFindService/CellPhone/i-strategy/push-alert?type=mobilephone`, '_blank');
    },
    handleTrial() {
      this.$Talog({
        id: 'iFinD_sjgw_sy_sysq'
      });
      window.open(`${location.origin}/index.php/Jgbweb/index/cellphoneapply?source=mobile#/Trial?source=mobile#/`, '_blank');
    },
    handleSwitchLang() {
      if (window.lang === 'en') {
        Cookies.set('ifindlang', 'cn');
      } else {
        Cookies.set('ifindlang', 'en');
      }
      location.reload();
    },
    getLanguage() {
      return window.lang;
    },
    handleSwipeChange(index) {
      this.currentTab = index;
    },
    handleTabChange(value) {
      this.$refs.mySwiper.swipeTo(value);
    }
  },
  mounted() {
    this.changeBarWidth();
  },
  watch: {
    currentTab: {
      handler() {
        this.changeBarWidth();
      },
    }
  }
};
</script>
<style lang="less" scoped>
.home-container {
  /deep/ .atom-swipe-item {
    margin-top: 0.26rem;
    padding: 0 0.16rem;
  }
  /deep/ .atom-swipe {
    box-shadow: 5px 27px 24px 17px rgba(174, 174, 174, 0.19);
  }
  /deep/ .atom-tab {
    background-color: transparent !important;
  }
  /deep/ .atom-tabs__line {
    background-color: #3377E8;
  }
  /deep/ .atom-tabs--line .atom-tabs__wrap {
    background-color: transparent;
  }
  .c_header {
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.56rem;
    background: url(~@/assets/imgs/c_header.png) repeat;
    background-size: cover;
    .c_switch {
      width: 20px;
      height: 20px;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
      &.en {
        background-image: url(~@/assets/imgs/en_icon.png);
      }
      &.cn {
        background-image: url(~@/assets/imgs/cn_icon.png);
      }
    }
    .c_logo {
      width: 0.51rem;
      height: 0.16rem;
      background: url(~@/assets/imgs/c_logo.png) no-repeat center center;
      background-size: contain;
    }
  }
  .c_banner {
    padding-top: 0.68rem;
    height: 2.88rem;
    background: url(~@/assets/imgs/c_banner.png) no-repeat center center;
    background-size: cover;
    .c_main_title {
      margin: 0 auto;
      width: 2.42rem;
      height: 1.1rem;
      background: url(~@/assets/imgs/home_title.png) no-repeat center center;
      background-size: contain;
    }
  }
  .c_seperate {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.6rem;
    background: url(~@/assets/imgs/c_seperate.png) no-repeat center center;
    background-size: cover;
    font-family: AlibabaPuHuiTi-Bold;
    font-size: 0.2rem;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 0.28rem;
    font-weight: 700;
  }
  .bg_wrap {
    background-image: linear-gradient(0deg, #ffffff 0%, #f2f8fe 83%);
  }
  .c_title {
    margin-top: 0.8rem;
    margin-bottom: 0.16rem;
    font-family: AlibabaPuHuiTi-Bold;
    font-size: 0.2rem;
    color: #191919;
    letter-spacing: 0;
    line-height: 0.28rem;
    font-weight: 700;
    text-align: center;
  }
  .c_beian {
    text-align: center;
    font-size: 12px;
    color: #666;
  }
  .c_func {
    padding: 0 0.16rem;
    li {
      position: relative;
      margin-top: 0.16rem;
      display: flex;
      height: 1.06rem;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 0.06rem;
      &:nth-child(1) {
        background-image: url(~@/assets/imgs/func_inter_bg.png);
        .c_right {
          background-image: url(~@/assets/imgs/func_inter_right.png);
        }
      }
      &:nth-child(2) {
        background-image: url(~@/assets/imgs/func_data_bg.png);
        .c_right {
          background-image: url(~@/assets/imgs/func_data_right.png);
        }
      }
      &:nth-child(3) {
        background-image: url(~@/assets/imgs/func_chat_bg.png);
        .c_right {
          background-image: url(~@/assets/imgs/func_chat_right.png);
        }
      }
      &:nth-child(4) {
        background-image: url(~@/assets/imgs/func_write_bg.png);
        .c_right {
          background-image: url(~@/assets/imgs/func_write_right.png);
        }
      }
      .c_right {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1.29rem;
        height: 0.9225rem;
        background-position: 0 0.13rem;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .c_left {
        flex: 1;
        padding-top: 0.16rem;
        padding-left: 0.16rem;
        position: relative;
        z-index: 1;
      }
      .func_title {
        margin-bottom: 0.04rem;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 0.16rem;
        color: #191919;
        font-weight: 900;
      }
      .func_desc {
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 0.13rem;
        color: #666666;
        line-height: 0.16rem;
        font-weight: 400;
        width: 60%;
      }
    }
  }
  .c_solution_block {
    margin-top: 0.4rem;
    height: 5.48rem;
    padding: 0.4rem 0.16rem 0 0.16rem;
    background: url(~@/assets/imgs/solution_bg.png) no-repeat center center;
    .c_title {
      margin-top: 0;
    }
    .c_content {
      height: 3.7rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
      grid-gap: 0.08rem 0.08rem;
    }
    .c_solute_item {
      padding: 0.16rem;
      background: #ffffff;
      border-radius: 0.06rem;
      .c_solute_item_title {
        height: 0.24rem;
        display: flex;
        justify-content: space-between;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 0.16rem;
        color: #191919;
        font-weight: 700;
      }
      .c_solute_item_desc {
        margin-top: 0.16rem;
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 0.13rem;
        color: #666666;
        text-align: justify;
        line-height: 0.16rem;
        font-weight: 400;
      }
      &:nth-child(1) {
        .c_icon {
          background-image: url(~@/assets/imgs/bond_icon.png);
        }
      }
      &:nth-child(2) {
        .c_icon {
          background-image: url(~@/assets/imgs/bank_icon.png);
        }
      }
      &:nth-child(3) {
        .c_icon {
          background-image: url(~@/assets/imgs/fund_icon.png);
        }
      }
      &:nth-child(4) {
        .c_icon {
          background-image: url(~@/assets/imgs/company_icon.png);
        }
      }
      &:nth-child(5) {
        .c_icon {
          background-image: url(~@/assets/imgs/futures_icon.png);
        }
      }
      &:nth-child(6) {
        .c_icon {
          background-image: url(~@/assets/imgs/other_icon.png);
        }
      }
      .c_icon {
        width: 0.24rem;
        height: 0.24rem;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
  .c_instru {
    margin-top: 0.24rem;
    margin-bottom: 0.64rem;
    height: 3.68rem;
    background-image: url(~@/assets/imgs/c_instru_bg.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
  .c_footer {
    margin-bottom: 68px;
    padding-top: 0.11rem;
    height: 1.4rem;
    background: #080f1f;
    display: flex;
    justify-content: center;
    .small_text {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 0.12rem;
      transform: scale(0.8);
      color: #ffffff;
      text-align: center;
      line-height: 0.16rem;
      font-weight: 400;
      & > div {
        margin-bottom: 0.04rem;
      }
    }
  }
  .c_fixed_bottom {
    position: fixed;
    bottom: 0;
    height: 0.68rem;
    display: flex;
    justify-content: space-between;
    padding: 0.08rem 0.16rem;
    width: 100%;
    background: #fff;
    z-index: 99;
    .btn {
      width: 1.68rem;
      height: 0.38rem;
      line-height: 0.38rem;
      text-align: center;
      border-radius: 0.06rem;
      &.download {
        border: 1px solid #3377e8;
        border-radius: 0.06rem;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 16px;
        color: #3377e8;
        font-weight: 700;
      }
      &.trial {
        background-image: linear-gradient(90deg, #1bc5d9 0%, #1b63d9 100%);
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 16px;
        color: #ffffff;
        font-weight: 700;
      }
    }
  }
}
</style>

<style lang="less">
.c_tab_style {
  .atom-tab__text--ellipsis {
    display: block !important;
    white-space: nowrap !important;
  }
}
</style>
